import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { EmptyData } from '@shared/models';
import { ElasticSearchService } from '@shared/services/elastic-search';

@Component({
  selector: 'app-listing-tutos',
  imports: [ImageComponent, RouterLink, SvgComponent],
  templateUrl: './listing-tutos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingTutosComponent extends AbstractDynamicComponent<EmptyData> {
  protected readonly tutos = toSignal(inject(ElasticSearchService).getTutos());
}
